module.exports = __webpack_public_path__ + "static/media/ic_name_info.fc11a260.svg";